import { zipObj } from 'ramda';

export const apiNameEnums = [
  'GET_ACTIVITY_TYPES',
  'GET_CHANNELS',
  'GET_ISHCOENABLED',
  'GET_JOURNEY_METADATA',
  'GET_LIMITS',
  'GET_LOCALIZATION',
  'GET_METRICS',
  'GET_TIME_PERIODS',
  'GET_USER_DATA',
  'POST_INITIALIZE',
];

//this creates an object where key and value are the same string as in the above array
const enums = zipObj(apiNameEnums, apiNameEnums);

export default enums;



// WEBPACK FOOTER //
// ./src/Enums/apiNames.js